import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import {
  neutralDark,
  neutralGrey,
  neutralWhite,
  warrior,
  white,
} from '../../../constants/color';

export const S = {
  RefundLabel: styled.View`
    align-self: baseline;
    padding: 3px 5px;
    border-radius: 3px;
    margin-bottom: 5px;
    background-color: ${warrior};
  `,
  RefundLabelText: styled.Text`
    color: ${white};
    font-size: 12px;
    line-height: 17px;
  `,
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: neutralWhite,
    flexDirection: 'row',
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
  },
  imageSection: {
    borderRadius: 3,
    height: 80,
    marginRight: 10,
    overflow: 'hidden',
    width: 80,
  },
  image: {
    height: 80,
    width: 80,
    borderRadius: 3,
  },
  detail: {
    flex: 3,
    position: 'relative',
    minHeight: 90,
  },
  title: {
    color: warrior,
    fontSize: 15,
    lineHeight: 21,
  },
  sku: {
    flex: 1,
    color: neutralDark,
    fontSize: 13,
    lineHeight: 17,
    marginTop: 2,
    marginRight: 2,
  },
  skuWithGreyness: {
    marginTop: 6,
  },
  meta: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  amount: {},
  price: {
    color: warrior,
    fontSize: 12,
    lineHeight: 17,
    marginRight: 2,
  },
  inverseGreyness: {
    color: neutralDark,
  },
  labelsContainer: {
    marginTop: 4,
    flexDirection: 'row',
    alignItems: 'center',
  },
  placeOfShipment: {
    borderColor: neutralGrey,
    borderWidth: 1,
    borderRadius: 3,
    paddingHorizontal: 3,
  },
  placeOfShipmentText: {
    fontSize: 11,
    color: neutralDark,
  },
});

export default styles;
